import { defineComponent as _defineComponent } from 'vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzAdviceCard',
  props: {
    slug: null,
    title: null,
    subtitle: null,
    cover: null,
    category: null,
    imageLoading: null,
    isCategory: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var router = useRouter();
    var link = computed(function () {
      var name = props.isCategory ? 'pages-slug' : 'page-slug';
      return app.localePath({
        name: name,
        params: {
          slug: props.slug
        }
      });
    });
    var imageSize = computed(function () {
      return props.isCategory ? '146x146' : '343x194';
    });
    var attribute = computed(function () {
      return props.isCategory ? props.title : props.category;
    });
    var cardTitle = computed(function () {
      return props.isCategory ? props.subtitle : props.title;
    });
    return {
      __sfc: true,
      props: props,
      app: app,
      router: router,
      link: link,
      imageSize: imageSize,
      attribute: attribute,
      cardTitle: cardTitle,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});